import getConfig from "next/config";

const { serverRuntimeConfig: configuration = {} } = getConfig() || {};

export const cmsConfig: {
  projectId: string;
  dataset: string;
  apiVersion: string;
  readToken: string;
  editorToken: string;
  revalidate: number;
  studioBaseUrl: string;
} = configuration?.cms;

export const baseURL = configuration.baseURL;

export const algoliaConfig: {
  indexName: string;
  applicationID: string;
  searchApiKey: string;
} = configuration?.algoliaConfig;

export const commerceConfig: {
  host: string;
  omniChannelHost: string;
  omniChannelApiKey: string;
  currencyMappings: { [key: string]: string };
} = {
  ...configuration?.commerce,
  host: (process.env.API_HOST || configuration?.commerce?.host)?.replace?.(/\/$/, "") || process.env.NEXT_PUBLIC_API_HOST,
  omniChannelHost: (
    process.env.OMNI_CHANNEL_API_HOST || configuration?.commerce?.omniChannelHost
  )?.replace?.(/\/$/, ""),
  omniChannelApiKey: process.env.OMNI_CHANNEL_API_KEY || configuration?.commerce?.omniChannelApiKey,
};

export const sendGridConfig: {
  apiKey: string;
  adminEmail: string;
  from: string;
  templateIdEn: string;
  templateIdAr: string;
} = configuration?.sendGrid;

export const webHookToken: string = configuration?.webHookToken;

export const azureStorageBaseUrl: string = configuration?.azureStorageBaseUrl;

export const locationMappings: { [key: string]: string } = configuration?.locationMappings;
export const brandId: string = configuration?.brandId;
export const rootDir: string = configuration?.rootDir;

export const cacheDir: string = configuration?.cacheDir;

export const transactionalSites: string[] = configuration?.transactionalSites;

export const openIdConnect: {
  clientId: string;
  clientSecret: string;
  policy: string;
  authorizeUrl: string;
  tokenUrl: string;
  logoutUrl: string;
  userinfoUrl: string;
} = configuration?.openIdConnectConfig;

export const seoInfo: {
  title: string;
  description: string;
} = configuration?.seoInfo;

//  TODO: Move to cms config
export const gtmId: string = configuration?.gtmId;

// Configuration for Azure AD B2C
export const adb2cStateEncryptionKeys = {
  secretKeyEnv:
    process.env.SECRET_KEY || "1234567890abcdef1234567890abcdef1234567890abcdef1234567890abcdef",
  ivEnv: process.env.IV || "abcdef1234567890abcdef1234567890",
};

export const apiInternalCacheRevalidateTime = parseInt(
  process.env.API_INTERNAL_CACHE_REVALIDATE_TIME || "32400",
  10,
);

export const apiAlgoliaCacheRevalidateTime = parseInt(process.env.API_ALGOLIA_CACHE_REVALIDATE_TIME || "3600", 10);
export const algoliaCacheOptions: {
  disabled: boolean;
  saveToDisk: boolean;
  stringifyInWorker: boolean;
} = JSON.parse(process.env.ALGOLIA_CACHE_OPTIONS || "{}");

export const currencyMappings: Record<string, string> = {
  "sa-en": "SAR",
  "sa-ar": "SAR",
  "ae-en": "AED",
  "ae-ar": "AED",
  "kw-en": "KWD",
  "kw-ar": "KWD",
  "qa-en": "QAR",
  "qa-ar": "QAR",
  "eg-en": "EGP",
  "eg-ar": "EGP",
};

export const azureAdB2cConfig: {
  clientId: string;
  clientSecret: string;
  wellKnownUrl: string;
} = configuration.azureAdb2c;

export const freshdeskConfig: {
  baseUrl: string;
  username: string;
  password: string;
} = {
  baseUrl: process.env.FRESHDESK_BASE_URL || "",
  username: process.env.FRESHDESK_USERNAME || "",
  password: process.env.FRESHDESK_PASSWORD || "",
};

export const orderTrackingConfig: {
  baseUrl: string;
  username: string;
  password: string;
  secretKey: string;
} = {
  baseUrl: process.env.ORDER_TRACKING_API_BASE_URL || "",
  username: process.env.POS_BASIC_AUTH_USERNAME || "",
  password: process.env.POS_BASIC_AUTH_PASSWORD || "",
  secretKey: process.env.ORDER_TRACKING_SECRET_KEY || "",
};

export const mReserveConfig: {
  baseUrl: string;
  apiKey: string;
  clientId: string;
  clientSecret: string;
} = {
  baseUrl: (process.env.MRESERVE_API_URL || "https://uatapimreserve.magrabi.com/api/v1").replace(/\/$/, "") + "/",
  apiKey: process.env.MRESERVE_API_KEY || "retail-site",
  clientId: process.env.MRESERVE_CLIENT_ID || "",
  clientSecret: process.env.MRESERVE_CLIENT_SECRET || "",
};

/** Flow Option 2: CKO payment-session submit from storefront (server-only). */
export const checkoutFlowApiUrl: string | undefined = process.env.CHECKOUT_FLOW_API_URL;
export const checkoutFlowSecretKey: string | undefined = process.env.CHECKOUT_FLOW_SECRET_KEY;
